export default class AudioEvent {
    /**
     *
     * @type {AudioEvent}
     * @memberof AudioEvent
     */
    static #instance;
    /**
     *
     * @type {Array<Function>}
     * @memberof AudioEvent
     */
    playingCallbacks = [];
    /**
     * callback of play end
     * @type {Array<Function>}
     * @memberof AudioEvent
     */
    playEndCallbacks = [];

    static get Instance() {
        if(this.#instance == null) {
            this.#instance = new AudioEvent();
        }

        return this.#instance;
    }

    /**
     * add callback to call, on audio playing
     * @param {Function} callback 
     */
    addPlayingCallback(callback) {
        this.playingCallbacks.push(callback);
    }

    clearPlayingCallBacks() {
        this.playingCallbacks = [];
    }

    doPlayingCallbacks() {
        if(this.playingCallbacks.length == 0) return;

        this.playingCallbacks.forEach(element => {
            element();
        });
    }

    addPlayEndCallback(callback) {
        this.playEndCallbacks.push(callback);
    }

    doPlayEndCallback() {
        if(this.playEndCallbacks.length == 0) return;

        this.playEndCallbacks.forEach(element => {
            element();
        });

        this.clearPlayEndCallbacks();
    }

    clearPlayEndCallbacks() {
        this.playEndCallbacks = [];
    }
}